import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Spacer from 'components/Shared/Spacer';
import { BaseButton } from 'components/Shared/Buttons';
import useOptimizelyDecisions from 'lib/hooks/useOptimizelyDecisions';
import { contactBarStyles } from './styles';

interface Props {
  phoneNumber: string | null;
  className?: string;
  isSubmitted: boolean;
  openLeadForm: () => void;
  acceptsLeads: boolean;
}

export default function ContactBar({
  phoneNumber,
  className,
  openLeadForm,
  isSubmitted,
  acceptsLeads,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const { testLeadCTA } = useOptimizelyDecisions();
  const translationVariant = testLeadCTA ? 'vdp.requestInfo' : 'vdp.checkAvailability';

  return (
    <div className={classNames('bar', className)} data-testid="contact-bar">
      {phoneNumber && (
        <a className="button" href={`tel:${phoneNumber}`} target="_parent">
          {t('vdp.actions.call')}
        </a>
      )}
      {phoneNumber && acceptsLeads && <Spacer size="16px" />}
      {acceptsLeads && (
        <BaseButton
          onClick={openLeadForm}
          className={`contact-bar-button ${isSubmitted ? 'disabled' : ''}`}
        >
          {isSubmitted ? t('leadForm.contacted') : t(translationVariant)}
        </BaseButton>
      )}

      <style jsx>{contactBarStyles}</style>
    </div>
  );
}
